import { mm2px, px2mm } from "@/utils/size"
import { Input } from "antd"
import { useMemo } from "react"
import { numberFixTo } from "../UnitPanel/components/common/utils"

interface InputWithMMProps {
  value: number
  onChange: (val: number) => void
  onBlur: () => void
  disabled?: boolean
}

export const InputWithMM = (props: InputWithMMProps) => {
  const {value, onChange, onBlur, disabled = false} = props;

  const inVal = useMemo(() => {
    return numberFixTo(px2mm(value), 2)
  }, [value])

  const handleChange = (e) => {
    const val = Number(e.target.value)
    onChange(numberFixTo(mm2px(val), 2))
  }

  return <Input
    onBlur={onBlur}
    onChange={handleChange}
    disabled={disabled}
    type="number"
    value={inVal}
    addonAfter='mm'
  />
}